import { inject, Pipe, PipeTransform } from '@angular/core';
import { DomSanitizer } from '@angular/platform-browser';
import { Format2Pipe } from './format2.pipe';
import { IEntity } from '../interface/IEntity';
import { ModelProperty } from '../engine/model-property';

@Pipe({
  name: 'format2WithSanitizerPipe',
  standalone: true,
})
export class Format2WithSanitizerPipe
  extends Format2Pipe
  implements PipeTransform
{
  private domSanitizer = inject(DomSanitizer);

  public override applyFormat(
    value: any,
    model?: ModelProperty,
    entity?: IEntity,
    notApply?: boolean,
    tooltip?: boolean,
    joinArray? : boolean,
  ) {
    const result = super.applyFormat(value, model, entity, notApply, tooltip, joinArray);
    if (model && model.formatter && model.formatter.type === 'gmaps') {
      return this.domSanitizer.bypassSecurityTrustHtml(result);
    }
    return result;
  }
}
